import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { SearchRequest } from '@search/interfaces/search-request.intarface';
import {
  ProductSearchActions,
  ProductSearchSelectors,
} from '@search/store/search.slice';
import { SearchNavbarBaseSubformComponent } from '@shared/components/search-layout/search-navbar/search-navbar-base-subform/search-navbar-base-subform.component';

import { AlcoholicDrinkType } from './../../../products/interfaces/alcoholic-drink-type';
import { NonAlcoholicDrinkType } from './../../../products/interfaces/non-alcoholic-drink-type';
import { OtherAlcoholType } from './../../../products/interfaces/other-alcohol-type';
import { OtherSpiritType } from './../../../products/interfaces/other-spirit-type';
import { SpiritType } from './../../../products/interfaces/spirit-type';
import { originalOrder } from './../../../shared/pipes/keyvalue-pipe-sort';

@Component({
  selector: 'app-search-category-select',
  templateUrl: './search-category-select.component.html',
  styleUrls: ['./search-category-select.component.scss'],
})
export class SearchCategorySelectComponent
  extends SearchNavbarBaseSubformComponent
  implements OnInit
{
  @Input() override data?: {
    additionalUpdater?: any;
  };

  form = this.fb.group({
    drinkType: this.fb.control(null),
  });

  originalOrder = originalOrder;

  override ngOnInit(): void {
    this.store
      .select(ProductSearchSelectors.selectSearchValue)
      .subscribe((value) => {
        if (
          value.drinkTypeList &&
          value.drinkTypeList.length > 0 &&
          this.data?.additionalUpdater
        ) {
          this.form.get('drinkType')?.setValue(value.drinkTypeList);
        }
      });
  }

  lastSelectedDrinkTypes: Array<string> | undefined = [];

  drinkTypes = [
    {
      groupName: 'SEARCH.SEARCH_BAR.CATEGORY.ALCOHOLIC_DRINK_TYPE',
      options: Object.values(AlcoholicDrinkType).map((alcType) => {
        switch (alcType) {
          case AlcoholicDrinkType.Spirit:
            return {
              groupName: 'SEARCH.SEARCH_BAR.TITLE.SPIRIT_TYPE',
              value: 'SPIRIT',
              options: Object.values(SpiritType).map((spiritType) => {
                if (spiritType !== SpiritType.Other) {
                  return {
                    name: 'SEARCH.SEARCH_BAR.SPIRIT_TYPE.' + spiritType,
                    value: 'SPIRIT.' + spiritType,
                  };
                } else {
                  return {
                    groupName: 'SEARCH.SEARCH_BAR.TITLE.OTHER_SPIRIT_TYPE',
                    value: 'SPIRIT.OTHER',
                    options: Object.values(OtherSpiritType).map(
                      (otherSpiritType) => ({
                        name:
                          'SEARCH.SEARCH_BAR.OTHER_SPIRIT_TYPE.' +
                          otherSpiritType,
                        value: 'SPIRIT.OTHER.' + otherSpiritType,
                      })
                    ),
                  };
                }
              }),
            };
          case AlcoholicDrinkType.Other:
            return {
              groupName: 'SEARCH.SEARCH_BAR.TITLE.OTHER_ALCOHOL_TYPE',
              value: 'OTHER',
              options: Object.values(OtherAlcoholType).map((otherAlcType) => ({
                name: 'SEARCH.SEARCH_BAR.OTHER_ALCOHOL_TYPE.' + otherAlcType,
                value: 'OTHER.' + otherAlcType,
              })),
            };
          default:
            return {
              name: 'SEARCH.SEARCH_BAR.ALCOHOLIC_DRINK_TYPE.' + alcType,
              value: alcType,
            };
        }
      }),
    },
    {
      groupName: 'SEARCH.SEARCH_BAR.CATEGORY.NON_ALCOHOLIC_DRINK_TYPE',
      options: Object.values(NonAlcoholicDrinkType).map((type) => ({
        name: 'SEARCH.SEARCH_BAR.NON_ALCOHOLIC_DRINK_TYPE.' + type,
        value: type,
      })),
    },
  ];

  updateValue(filter?: any) {
    this.clear();
    if (filter && filter[this.property]) {
      this.form.controls['drinkType'].setValue(filter[this.property]);
      this.valueChanged(filter[this.property]);
    }
    if (!filter) {
      this.clear();
    }
  }

  valueChanged(selectedDrinkTypes?: Array<string>): void {
    if (
      JSON.stringify(this.lastSelectedDrinkTypes) !==
        JSON.stringify(selectedDrinkTypes) &&
      selectedDrinkTypes !== null
    ) {
      this.lastSelectedDrinkTypes = selectedDrinkTypes;
      this.store.dispatch(
        this.filterUpdater.trigger({
          filter: {
            [this.property]: selectedDrinkTypes,
          },
        })
      );
      if (this.data?.additionalUpdater) {
        this.store.dispatch(this.data?.additionalUpdater.trigger());
      }
    }
  }

  override clear() {
    this.form.reset();
    this.valueChanged(undefined);
  }
}
